module.exports = __webpack_public_path__ + "static/img/haiwai_04.c7bbf1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callMe/haiwai_04.png
// module id = +MyL
// module chunks = 3